/**
 * Asynchronously loads the components for Employer Placement Drives
 */

import { lazyLoad } from 'utils/loadable';

export const EmployerPlacementDashboard = lazyLoad(
  () => import('./PlacementDashboard'),
  module => module.EmployerPlacementDashboard,
);

export const EmployerCreateDrive = lazyLoad(
  () => import('./EditDrive'),
  module => module.EmployerEditDrive,
);

export const EmployerDriveDetails = lazyLoad(
  () => import('./DriveDetails'),
  module => module.EmployerDriveDetails,
);

export const EmployerDriveJobs = lazyLoad(
  () => import('./DriveJobs'),
  module => module.EmployerDriveJobs,
);


export const EmployerCreateCommunication = lazyLoad(
  () => import('./CreateCommunication'),
  module => module.CreateCommunication,
);